import { EnvironmentVariables } from '../types/environment-variables';
import { HeaderData } from '../types/ee-header';

export const getBasketLink = (
  headerData: HeaderData | null,
  envData: EnvironmentVariables,
): string => {
  if (!headerData) return '';

  const globalMasthead = headerData[':items']?.global_masthead_copy;
  if (!globalMasthead) return '';

  const devLink =
    globalMasthead.linkToBasketPage ??
    '/content/ee/business/en/basket?session=false';
  const prodLink =
    globalMasthead.linkToEEBasketPage ??
    '/content/ee/business/en/ee-basket?session=false';

  return envData.environment === 'dev' ? devLink : prodLink;
};
